import mediumZoom, { type Zoom } from 'medium-zoom'

export default defineNuxtPlugin(nuxtApp => {
  // 确保DOM已挂载
  const selector = '.image-zoomable'
  const zoom: Zoom = mediumZoom(selector, {
    // 边距
    margin: 0,
    // 背景色
    background: '#ffffff80',
    // 滚动还原阈值
    scrollOffset: 0,
  })

  // (re-)init为新渲染的页面，也工作在SPA模式（客户端路由）
  nuxtApp.hook('page:finish', () => {
    zoom.detach(selector).attach(selector)
  })

  // 让NuxtApp作为helper可用
  nuxtApp.provide('mediumZoom', zoom)
})
